const state = {
   roleList:null,
    menuList: null,
    operationList:null
}

const mutations = {
    SET_ROLELIST: ( state, data) => {
        state.roleList = data
    },
    SET_MENULIST: ( state, data) => {
        state.menuList = data
    },
    SET_OPERATIONLIST: (state, data) => {
        state.operationList = data
    }
}

const actions = {
    setRoleList( { commit }, data) {
        commit('SET_ROLELIST', data)
    },
    setMenuList( { commit }, data) {
        commit('SET_MENULIST', data)
    },
    setOperationList({ commit }, data) {
        commit('SET_OPERATIONLIST', data)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
